<template>
  <ProductViewSizeTable :produkt="produkt" :sport="sport"/>
  <div class="product-size-explain" v-html="groessenTabRichtigMessen"></div>
</template>

<script>
import {computed, onMounted} from "vue";
import ProductViewSizeTable from "~/components/ProductViewSizeTable.vue";

import {useProductStore} from "~/store/productstore";


export default {
  name: "ProductViewSize",
  components: {ProductViewSizeTable},
  props: {
    produkt: String,
    sport: String
  },
  setup() {
    const productstore = useProductStore();

    onMounted(() => {
      let allElements = document.getElementsByClassName("previewimage");
      for (let i = 0; i < allElements.length; i++) {
        allElements[i].src = allElements[i].dataset.src;
      }
    });

    return {
      groessenTabRichtigMessen: computed(() => productstore.getRichtigMessenInfo),
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~/assets/scss/settings/_config.scss" as *;

.product-size-explain {
  position: relative;
  padding: 20px;

  .block-question {
    position: absolute;
    bottom: 0;
  }
}

:deep(.richtig-messen .row) {
  display: flex;
}

:deep(.richtig-messen .col-33:nth-child(1)) {
  width: 30%;
  padding-right: 30px;
  padding-top: 60px;
  text-align: center;
}

:deep(.richtig-messen .col-33:nth-child(1) h3) {
  font-size: 18px;
  margin-bottom: 20px;
}

:deep(.richtig-messen .col-33:nth-child(1) p) {
  font-weight: 600;
}

:deep(.richtig-messen .col-33:nth-child(3)) {
  width: 30%;
  padding-left: 30px;
  padding-top: 70px;
}

:deep(.richtig-messen .col-33:nth-child(3) h4) {
  color: #0071b9;
  font-weight: 600;
}

:deep(.richtig-messen .col-33:nth-child(2)) {
  width: 40%;
}

:deep(.block-question) {
  width: 50%;
  display: block;
  background: #ccc;
  text-align: center;
  padding: 20px;
  margin: 80px auto;
}

:deep(.block-question p) {
  margin-bottom: 0;
}

@media (max-width: 740px) {
  :deep(.richtig-messen .row) {
    flex-direction: column;
  }

  :deep(.richtig-messen .col-33:nth-child(1)) {
    width: 100%;
  }

  :deep(.richtig-messen .col-33:nth-child(2)) {
    width: 50%;
    margin: 0 auto;
  }

  :deep(.richtig-messen .col-33:nth-child(3)) {
    width: 100%;
  }
}
</style>
